import { render, staticRenderFns } from "./search-single-facet.vue?vue&type=template&id=0a578954"
import script from "./search-single-facet.vue?vue&type=script&lang=js"
export * from "./search-single-facet.vue?vue&type=script&lang=js"
import style0 from "../core/transition.less?vue&type=style&index=0&prod&lang=less&external"
import style1 from "./search-facets.less?vue&type=style&index=1&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports